<template>
  <layout-main-inner title="首页设置">
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">
        <el-button
          type="primary"
          @click="addProduct">新增首页</el-button>
      </template>
      <template slot="form">
        <el-input
          v-model="config.pageName"
          placeholder="请输入首页名称"
          clearable=""
          style="width: 200px;margin-left: 10px;"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="主页名称"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.pageName }}
            <el-tag
              v-if="row.isHomepage===1"
              type="success">当前主页</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="用户数"
          prop="viewUserCount"></el-table-column>
        <el-table-column
          :resizable="false"
          label="总浏览数量"
          prop="viewCount"></el-table-column>
        <el-table-column
          label="发布状态"
          width="120">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.status===1"
              type="success">已发布</el-tag>
            <el-tag
              v-if="row.status===0"
              type="info">未发布</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="创建时间"
          width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :resizable="false"
          width="160">
          <template slot-scope="{row}">
            <el-button
              type="warning"
              @click="update(row)">编辑</el-button>
            <el-dropdown v-if="row.isHomepage === 0">
              <el-button
                type="info"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu
                slot="dropdown">
                <el-dropdown-item
                  v-if="row.isHomepage === 0 && row.status === 0"
                  @click.native="deletePage(row)">删除</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isHomepage === 0 && row.status === 0"
                  @click.native="publishportalpage(row, 1)">发布</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isHomepage === 0 && row.status === 1"
                  @click.native="publishportalpage(row, 0)">取消发布</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isHomepage === 0 && row.status === 1"
                  @click.native="publishhomepage(row)">设为主页</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination
          slot="footer"
          background
          :current-page.sync="config.pageNum"
          :page-size="config.pageSize"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange">  </el-pagination>
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
// import AddGatewayConfirmModal from './busi/add-gateway-confirm-modal.vue'
export default {
  name: 'WxappPortalList',
  components: { },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, pageName: null }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    console.log('activated')
    this.fetchList()
  },
  mounted() {
    console.log('mounted')
    this.config.vendorId = this.userInfo.orgId
    this.fetchList()
  },
  methods: {
    update(row) {
      this.$router.push(`/wxapp-portal-edit?portalPageId=${row.portalPageId}&vendorId=${row.vendorId}&isHomepage=${row.isHomepage}`)
    },
    addProduct() {
      this.$router.push(`/wxapp-portal-edit?vendorId=${this.config.vendorId}`)
    },
    publishhomepage(row) {
      this.$confirm(`您确定将该页面设为主页?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('gateway/publishhomepage', {
            payload: { vendorId: row.vendorId, portalPageId: row.portalPageId },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    publishportalpage(row, status) {
      this.$confirm(`您确定${status === 1 ? '发布' : '取消发布'}该页面?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('gateway/publishportalpage', {
            payload: { vendorId: row.vendorId, portalPageId: row.portalPageId, status },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    deletePage(row) {
      this.$confirm('您确定删除该页面?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('gateway/deleteportalpage', {
            payload: { vendorId: row.vendorId, portalPageId: row.portalPageId },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('gateway/getportalpages', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
